import React from 'react';
import { StyledIco, StyledImg } from './InformationBlock.styles';
import { HeadPhoneMIcon, LegalEntityMIcon } from 'assets/icons';
import { GET_FILE_URL } from 'constants/url';

const ICON_MAP = {
  suppotIco: HeadPhoneMIcon,
  default: LegalEntityMIcon,
};

export const Avatar = ({ imgId }) => {
  if (!imgId) {
    return <StyledIco Icon={ICON_MAP.default} />;
  }

  if (imgId in ICON_MAP) {
    return <StyledIco Icon={ICON_MAP[imgId]} />;
  }

  return <StyledImg src={GET_FILE_URL(imgId)} alt="Avatar" />;
};
